import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceidService {

  private deviceId = new BehaviorSubject('ESP4380752');
  currentDeviceId = this.deviceId.asObservable();

  constructor() {
    if (this.checkCookie('deviceId')) {
      this.deviceId.next(this.getCookie('deviceId'));
    }
  }

  changeDeviceId(id: string) {
    if (id != null) {
      this.deviceId.next(id);
      this.setCookie('deviceId', id, 30);
    }
  }



  /** ===================================================
     * Cookies functions, because ngx-cookies won't work
     * ====================================================== */
  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  checkCookie(cname): boolean {
    const cValue = this.getCookie(cname);
    if (cValue && cValue.length !== 0) {
        return true;
    } else {
        return false;
    }
}
  /** ===========================
   * END cookies
   ============================== */
}

